class FilterValuesVM {
    name: string;
    startCondition: string;
    endCondition?: string;
    isGroupField?: boolean;
}